import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/testing/ui/MainModulev1/ui/MainModulev1.tsx");
